import { useAuth } from "../auth/auth-provider/auth-provider";
import { useEffect, useMemo } from "react";

import { useOpenDrawer } from "../custom-providers/open-drawer-provider/open-drawer-provider";
import { useOfflineModeStore } from "../stores/offlineModeStore";

import UserMenu from "./user-menu/user-menu";
import { Toolbar } from "devextreme-react";
import { Link } from "react-router-dom";

import logo from './../../assets/logo/logo.jpg';
import { persianLanguage } from "../../constants/persianTerms";
import { useSiteSettingsStore } from "../stores/siteSettingsStore";
import { DOMAIN } from "../../constants/api";


export default function MainNavbar() {
  const auth = useAuth();
  const { opened, setOpened } = useOpenDrawer();

  const isOffline = useOfflineModeStore((s) => s.isOffline);

  const managerClass = isOffline
    ? "user-select-none g-red-100 text-red-700 m-1 px-4 py-1 rounded relative"
    : "user-select-none g-green-100 text-green-700 m-1 px-4 py-1 rounded relative";

    const statusText = isOffline === null ? ""
        : isOffline
            ? persianLanguage.word.general.OFFLINE
            : persianLanguage.word.general.ONLINE;

    const toolbarItems = [
    {
        widget: "dxButton",
        location: "before",
        options: {
        icon: "menu",
        stylingMode: "text",
        onClick: () => setOpened((prev) => !prev),
        },
    },
    ];


    const {
        siteSettings,
        fetchSiteSettings,
    } = useSiteSettingsStore();

  if (!auth?.token) return null;

  return (
    <>
      <div className="columns-2">
        <div className="flex flex-row">
          <div>
            <Link to="/">
              <img className="mt-1 mx-3 logo" src={ `${DOMAIN}${siteSettings?.logoURL}`} alt="logo" />
            </Link>
          </div>

          <div className="mx-2">
            <Toolbar position="right" items={toolbarItems} rtlEnabled={true} />
          </div>

          {isOffline !== null && (
            <div className="mt-1 mx-2">
              <span className={`${managerClass} text-[10px]`}>
                {persianLanguage.word.general.MANAGER} {statusText}
              </span>
            </div>
          )}
        </div>

        <UserMenu />
      </div>

      <hr className="hr-style" />
    </>
  );
}